/* Titel und Description pro Route und Sprache.
   index.html trägt die statische Fassung für Crawler ohne JavaScript;
   PageMeta aktualisiert sie beim Navigieren in der SPA. */

export const SITE_URL = "https://vikavoronchuk.com";

const meta = {
  en: {
    "/": {
      title: "Viktoryia Varanchuk – Junior Controller, Zurich",
      description:
        "Viktoryia Varanchuk is a Junior Controller at Ringier AG in Zurich: financial reporting, budgeting and forecasting for an international media portfolio with SAP S/4HANA, Power BI and Excel.",
    },
    "/about-me": {
      title: "About me – Viktoryia Varanchuk",
      description:
        "From financial analysis in Tel Aviv to controlling in Switzerland: Viktoryia Varanchuk's career, working style and what drives her.",
    },
    "/experience": {
      title: "Experience – Viktoryia Varanchuk",
      description:
        "Positions at Ringier AG, Holy Fashion Group, Swiss International Airlines, Papaya Global and more, with responsibilities and reference letters.",
    },
    "/education": {
      title: "Education – Viktoryia Varanchuk",
      description:
        "International MBA from Bar-Ilan University, Bachelor of Economics in Finance and Credit (cum laude), plus data and German language courses.",
    },
    "/expertise": {
      title: "Expertise – Viktoryia Varanchuk",
      description:
        "Financial management, reporting and analysis, process automation, SAP S/4HANA, Power BI, Power Automate, SQL, and four languages.",
    },
  },
  de: {
    "/": {
      title: "Viktoryia Varanchuk – Junior Controllerin, Zürich",
      description:
        "Viktoryia Varanchuk ist Junior Controllerin bei der Ringier AG in Zürich: Reporting, Budgetierung und Forecasting für ein internationales Medienportfolio mit SAP S/4HANA, Power BI und Excel.",
    },
    "/about-me": {
      title: "Über mich – Viktoryia Varanchuk",
      description:
        "Von der Finanzanalyse in Tel Aviv zum Controlling in der Schweiz: Werdegang, Arbeitsweise und Antrieb von Viktoryia Varanchuk.",
    },
    "/experience": {
      title: "Berufserfahrung – Viktoryia Varanchuk",
      description:
        "Stationen bei Ringier AG, Holy Fashion Group, Swiss International Airlines, Papaya Global und weiteren, mit Aufgaben und Arbeitszeugnissen.",
    },
    "/education": {
      title: "Bildung – Viktoryia Varanchuk",
      description:
        "International MBA der Bar-Ilan University, Bachelor of Economics in Finance and Credit (cum laude) sowie Daten- und Deutschkurse.",
    },
    "/expertise": {
      title: "Kenntnisse – Viktoryia Varanchuk",
      description:
        "Finanzmanagement, Reporting und Analyse, Prozessautomatisierung, SAP S/4HANA, Power BI, Power Automate, SQL und vier Sprachen.",
    },
  },
};

/** Route ohne /de-Präfix, damit beide Sprachen dieselben Schlüssel nutzen. */
export const routeKeyFromPath = (pathname) => {
  const withoutLang = pathname.replace(/^\/de/, "");
  return withoutLang === "" ? "/" : withoutLang.replace(/\/$/, "") || "/";
};

export const getMeta = (language, pathname) => {
  const table = meta[language] ?? meta.en;
  return table[routeKeyFromPath(pathname)] ?? table["/"];
};

export default meta;
